import script from "./StoreProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreProfile.vue?vue&type=script&setup=true&lang=js"

import "./StoreProfile.vue?vue&type=style&index=0&id=1d0b0a1c&lang=css"

const __exports__ = script;

export default __exports__